import React, { Component } from 'react'
import { Box, Columns, Column, Control, Field, Button, Divider } from 'Components/common/bulma'
import { Input, Select, Output } from 'Components/common/form'
import Autosuggest from 'react-autosuggest'
import { getDataInput, mapPropsToState, validateData, getValues } from 'App/helpers'
import { multiply, find, propEq } from 'ramda'
import { v4 as uuid } from 'uuid'

/* eslint-disable */
function debounce(a, b, c) { var d, e; return function () { function h() { d = null, c || (e = a.apply(f, g)) } var f = this, g = arguments; return clearTimeout(d), d = setTimeout(h, b), c && !d && (e = a.apply(f, g)), e } }
/* eslint-enable */

const renderSuggestion = suggestion => (
  <div>
    {suggestion.nombre}
  </div>
)
const renderSuggestionProduct = suggestion => (
  <div>
    {suggestion.concatenado}
  </div>
)

class Concept extends Component {
  state = {
    value: '',
    valueProduct: '',
    data: this.props.conceptData,
    showErrors: false,
    query: '',
  }

  componentDidMount() {
    this.props.getUnits()
  }

  componentWillReceiveProps(nextProps) {
    let data;
    if (this.props.product !== nextProps.product) {
      const { claveProductoServicioSAT, unidad } = nextProps.product
      data = mapPropsToState(this.state.data, { ...nextProps.product, tasaIva: nextProps.product.tasaIVA, tasaIeps: nextProps.product.tasaIEPS })
      this.setState({ data, value: unidad || '' })
      this.props.getProductSat(claveProductoServicioSAT)
    }

    if (this.props.productSat !== nextProps.productSat) {
      const { concatenado } = nextProps.productSat
      this.setState({
        valueProduct: concatenado
      })
    }
  }

  getSuggestionValue = suggestion => {
    this.onChangeInput({
      target: {
        name: 'unit',
        value: suggestion.id,
      }
    })
    return suggestion.nombre;
  }

  getSuggestionValueProduct = suggestion => {
    this.onChangeInput({
      target: {
        name: 'claveProductoServicioSAT',
        value: suggestion.id,
      }
    })
    return suggestion.concatenado;
  }

  onChangeInput = ({ target }) => {
    const { name } = target
    const data = getDataInput(target, this.state.data)
    const field = data[name]

    this.setState({
      data,
      showErrors: false,
      showAccountErrors: false,
    }, () => {
      if (field.trigger && this[field.trigger]) {
        this[field.trigger](field)
      }
    })
  }

  onChangeUnit = (event, { newValue, method }) => {

    this.setState({
      value: newValue
    })
    if (method === 'type') {
      this.onChangeInput({
        target: {
          name: 'unit',
          value: '',
        }
      })
    }
  }
  onChangeClave = (event, { newValue, method }) => {

    this.setState({
      valueProduct: newValue
    })
    if (method === 'type') {
      this.onChangeInput({
        target: {
          name: 'claveProductoServicioSAT',
          value: '',
        }
      })
    }
  }

  onChangeQuery = (event, { newValue, method }) => {
    this.setState({
      query: newValue,
    })
  }

  onSuggestionsFetchRequested = debounce(({ value }) => {
    this.props.getUnits(value)
  }, 400)

  onSuggestionsClearRequested = () => {
    this.props.clearUnits()
  }

  onSuggestionsFetchRequestedProduct = debounce(({ value }) => {
    this.props.getProductService(value)
  }, 400)


  onSuggestionsClearRequestedProduct = () => {
    this.props.clearProductService()
  }

  onSuggestionSelected(event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) {
    event.stopPropagation();
    event.preventDefault();
  }

  onSuggestionProductSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
    this.props.getProduct(suggestion.id)
    event.stopPropagation();
    event.preventDefault();
  }

  getSubtotal = () => {
    const { quantity: { value: qty }, unitaryImport: { value: price }, discount: { value: discount = 0 } } = this.state.data
    return multiply(+qty, (+price - discount))
  }

  getIepsCalculado = (subtotal) => {
    const { tasaIeps: { value: iepsId } } = this.state.data
    const { iepsRates } = this.props
    const ieps = find(propEq('id', iepsId))(iepsRates)

    if (!ieps) {
      return 0
    }
    return subtotal * ieps.IEPS
  }

  getIvaCalculado = (subtotal, iepsC) => {
    const { tasaIva: { value: ivaId }, tipoCalculo: { value: calculo } } = this.state.data
    const { ivaRates } = this.props
    const iva = find(propEq('id', ivaId))(ivaRates)

    const amount = calculo === 1 ? subtotal : (subtotal + iepsC)

    if (!iva) {
      return 0
    }

    return multiply(amount, +iva.IVA)
  }
  getTotalCalculado = (subtotal, iepsC, ivaC) => {

    return subtotal + iepsC + ivaC
  }

  updateCalculations = () => {
    const subtotal = this.getSubtotal()
    const ieps = this.getIepsCalculado(subtotal)
    const iva = this.getIvaCalculado(subtotal, ieps)
    const total = this.getTotalCalculado(subtotal,
      ieps,
      iva,
    )
    const data = mapPropsToState(this.state.data, {
      subtotal,
      ieps,
      iva,
      total,
    })
    this.setState({ data })
  }

  addConcept = (addProduct) => {
    const { data, hasErrors } = validateData(this.state.data)
    if (hasErrors) {
      this.setState({
        data,
        showErrors: true,
      })
      this.props.addNotification({
        type: 'danger',
        message: '¡Favor de validar algunos campos!'
      })
      return
    }
    this.props.addConcept({ ...getValues(this.state.data), id: uuid() }, addProduct)
  }
  render() {
    const { data, showErrors } = this.state
    const { units, ivaRates, iepsRates, closeConceptModal,
      productService } = this.props
    return (
      <Box>
        <Divider content="CONCEPTO" />
        <Columns className="is-multiline">
          <Column className="is-half">
            <Select
              {...data.export}
              onChange={this.onChangeInput}
              showErrors={showErrors}
              hideEmpty
              options={this.props.exportation}
            />
          </Column>
          <Column className="is-half">
            <Select
              {...data.taxObject}
              onChange={this.onChangeInput}
              showErrors={showErrors}
              options={this.props.taxObject}
            />
          </Column>
          <Column className="is-one-quarter">
            <Input
              {...data.quantity}
              onChange={this.onChangeInput}
              showErrors={showErrors}
            />
          </Column>
          <Column>
            <Input
              {...data.description}
              onChange={this.onChangeInput}
              showErrors={showErrors}
            />
          </Column>
        </Columns>
        <Columns>
          <Column className="is-half">
            <Input
              {...data.identifier}
              onChange={this.onChangeInput}
              showErrors={showErrors}
            />
          </Column>
          <Column className="is-half">
            <Input
              {...data.customRequestNumber}
              onChange={this.onChangeInput}
              showErrors={showErrors}
            />
          </Column>
        </Columns>
        <Columns>
          <Column>
            <Field>
              <label className="label">{data.unit.label}</label>
              <Control>
                <Autosuggest
                  suggestions={units}
                  inputProps={{
                    value: this.state.value,
                    onChange: this.onChangeUnit,
                    className: 'input',
                    placeholder: data.unit.placeholder,
                  }}
                  onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                  getSuggestionValue={this.getSuggestionValue}
                  onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                  renderSuggestion={renderSuggestion}
                  onSuggestionSelected={this.onSuggestionSelected}
                />
              </Control>
              {(data.unit.errors && !!data.unit.errors.length && this.state.showErrors) &&
                <p className="has-text-danger help">{data.unit.errors[0].message}</p>}
            </Field>
          </Column>
        </Columns>
        <Columns>
          <Column>
            <Field>
              <label className="label">{data.claveProductoServicioSAT.label}</label>
              <Control>
                <Autosuggest
                  suggestions={productService}
                  inputProps={{
                    value: this.state.valueProduct,
                    onChange: this.onChangeClave,
                    className: 'input',
                    placeholder: data.claveProductoServicioSAT.placeholder,
                  }}
                  onSuggestionsClearRequested={this.onSuggestionsClearRequestedProduct}
                  getSuggestionValue={this.getSuggestionValueProduct}
                  onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedProduct}
                  renderSuggestion={renderSuggestionProduct}
                  onSuggestionSelected={this.onSuggestionSelected}
                />
              </Control>
              {(data.claveProductoServicioSAT.errors && !!data.claveProductoServicioSAT.errors.length && this.state.showErrors) &&
                <p className="has-text-danger help">{data.claveProductoServicioSAT.errors[0].message}</p>}
            </Field>
          </Column>
        </Columns>
        <Columns className="is-multiline">
          <Column>
            <Input
              {...data.unitaryImport}
              onChange={this.onChangeInput}
              showErrors={showErrors}
            />
          </Column>
        </Columns>
        <Columns>
          <Column className="is-half">
            <Input
              {...data.discount}
              onChange={this.onChangeInput}
              showErrors={showErrors}
            />
          </Column>
          <Column>
            <Output
              {...data.subtotal}
              onChange={this.onChangeInput}
              showErrors={showErrors}
            />
          </Column>
        </Columns>
        <Columns>
        </Columns>
        <Columns>
          <Column>
            <Select
              options={iepsRates}
              {...data.tasaIeps}
              onChange={this.onChangeInput}
              showErrors={showErrors}
            />
          </Column>
          <Column>
            <Output
              {...data.ieps}
              onChange={this.onChangeInput}
              showErrors={showErrors}
            />
          </Column>
        </Columns>
        <Columns>
          <Column>
            <Select
              options={ivaRates}
              {...data.tasaIva}
              onChange={this.onChangeInput}
              showErrors={showErrors}
            />
          </Column>
          <Column>
            <Output
              {...data.iva}
              onChange={this.onChangeInput}
            />
          </Column>
        </Columns>
        <Columns>
          <Column>
            <Output
              {...data.total}
              onChange={this.onChangeInput}
            />
          </Column>
          <Column>
            <Select
              hideEmpty={true}
              {...data.tipoCalculo}
              onChange={this.onChangeInput}
            />
          </Column>
        </Columns>
        <Columns>
          <Column className="has-text-right">
            <Button default className="margin-left-sm" onClick={() => this.addConcept()}>Agregar</Button>
            <Button default className="margin-left-sm" onClick={closeConceptModal}>
              Cancelar
            </Button>
          </Column>
        </Columns>
      </Box>
    )

  }
}

export default Concept